import styled from "styled-components";
import { CreateButton as RaCreateButton } from "react-admin";

export const Container = styled.div`
  width: 100%;
  padding: 24px 24px 48px;
  box-sizing: border-box;
  display: flex;
  justify-content: center;
`;

export const Content = styled.div`
  width: 100%;
  max-width: 1200px;
  display: flex;
  flex-direction: column;
  gap: 16px;
`;

export const HeaderRow = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  flex-wrap: wrap;
`;

export const Title = styled.h2`
  margin: 0;
  color: #212121;
  font-size: 24px;
  line-height: 1.2;
`;

export const Actions = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
  flex-wrap: wrap;
`;

export const CreateActionButton = styled(RaCreateButton)`
  && {
    background: #ed4e2a;
    color: #fff;
  }
  padding: 10px 16px;
  border-radius: 10px;
  text-decoration: none;
  font-weight: 600;
  font-size: 14px;
  box-shadow: 0 6px 16px rgba(237, 78, 42, 0.3);
  transition: transform 160ms ease, box-shadow 160ms ease;
  display: inline-flex;
  align-items: center;
  gap: 8px;

  &:hover,
  &:focus {
    background: #d8431f;
    color: #fff;
    transform: translateY(-1px);
    box-shadow: 0 8px 20px rgba(237, 78, 42, 0.35);
  }

  .MuiButton-label {
    background: transparent;
    padding: 0;
    border-radius: 0;
    box-shadow: none;
  }
`;

export const TableCard = styled.div`
  background: #fff;
  border-radius: 12px;
  border: 1px solid #eeeeee;
  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.06);
  overflow: hidden;
`;

export const TableHeader = styled.div`
  display: grid;
  grid-template-columns: 3fr 2fr 1fr 1fr 1fr 130px;
  align-items: center;
  gap: 16px;
  padding: 12px 20px;
  background: #fafafa;
  text-transform: uppercase;
  font-size: 12px;
  letter-spacing: 0.08em;
  color: #757575;
  border-bottom: 1px solid #f0f0f0;
`;

export const HeaderCell = styled.span`
  font-weight: 700;
`;

export const TableBody = styled.div``;

export const AddressRow = styled.div`
  display: grid;
  grid-template-columns: 3fr 2fr 1fr 1fr 1fr 130px;
  align-items: center;
  gap: 16px;
  padding: 16px 20px;
  border-bottom: 1px solid #f9f9f9;
  background: #fff;

  &:hover {
    background: #fbfbfb;
  }
`;

export const Cell = styled.div`
  display: flex;
  flex-direction: column;
  gap: 4px;
`;

export const FieldValue = styled.span`
  color: #212121;
  font-weight: 600;
  font-size: 14px;
  line-height: 1.3;
`;

export const RowActions = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-end;
`;

export const FormCard = styled.div`
  background: #fff;
  border-radius: 12px;
  border: 1px solid #eeeeee;
  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.06);
  padding: 16px;
  width: 100%;

  .MuiFormControl-root,
  .MuiInputBase-root {
    width: 100%;
  }
`;
